import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";

import "bootstrap/dist/css/bootstrap.css";
import "vue-select/dist/vue-select.css";
import 'primeicons/primeicons.css'

// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

import Login from "./components/Login.vue";
import OidcCallback from "./components/OidcCallback.vue";
import Biobank from "./components/Biobank.vue";
import Collections from "./components/Collections.vue";
import Collection from "./components/Collection.vue";
import CollectionNew from "./components/CollectionNew.vue";
import People from "./components/People.vue";
import Person from "./components/Person.vue";
import PersonNew from "./components/PersonNew.vue";
import User from "./components/User.vue";
import Admin from "./components/Admin.vue";
import AdminAccess from "./components/admin/AdminAccess.vue";
import AdminUsers from "./components/admin/AdminUsers.vue";
import AdminBiobanks from "./components/admin/AdminBiobanks.vue";
import AdminDomains from "./components/admin/AdminDomains.vue";
import AlsoKnown from "./components/AlsoKnown";
import AlsoKnownNew from "./components/AlsoKnownNew";
import Facts from "./components/Facts";
import Networks from "./components/Networks";
import NetworkNew from "./components/NetworkNew.vue";
import Network from "./components/Network.vue";

Vue.use(VueRouter);
// Vue.use(ElementUI);

const runtimeConfig = (typeof window !== "undefined" && window.__APP_CONFIG__)
    ? window.__APP_CONFIG__
    : {};
const routerMode = runtimeConfig.routerMode === "hash" ? "hash" : "history";
const routerBase = runtimeConfig.routerBase;

if (typeof window !== "undefined" && routerMode === "hash") {
    const searchParams = new URLSearchParams(window.location.search || "");
    const hasOidcCallbackState = searchParams.has("code")
        || searchParams.has("state")
        || searchParams.has("session")
        || (window.location.pathname === "/auth/oidc/callback" && searchParams.has("oidc_error"));
    const isAlreadyOnHashCallback = (window.location.hash || "").startsWith("#/auth/oidc/callback");
    if (hasOidcCallbackState && !isAlreadyOnHashCallback) {
        const callbackHash = "#/auth/oidc/callback" + (searchParams.toString() ? "?" + searchParams.toString() : "");
        window.location.replace(window.location.pathname + callbackHash);
    }
}

const router = new VueRouter({
    mode: routerMode,
    ...(routerBase ? {base: routerBase} : {}),
    linkActiveClass: "active",
    routes: [
        {path: "/", component: {render: h => h("div")}},
        {path: "/login", component: Login},
        {path: "/auth/oidc/callback", component: OidcCallback},
        {path: "/admin", component: Admin, children: [
            {path: "", redirect: () => localStorage.getItem("admin_last_tab") || "/admin/access"},
            {path: "access", component: AdminAccess},
            {path: "users", component: AdminUsers},
            {path: "biobanks", component: AdminBiobanks},
            {path: "domains", component: AdminDomains},
        ]},
        {path: "/user", component: User},
        {path: "/biobank", component: Biobank},
        {path: "/collections", component: Collections},
        {path: "/collections/:id", component: Collection},
        {path: "/subcollections/:id", component: Collection},
        {path: "/collection-new/", component: CollectionNew},
        {path: "/also-known-new/", component: AlsoKnownNew},
        {path: "/also-known/:id", component: AlsoKnown},
        {path: "/facts/:collection_id", component: Facts},
        {path: "/people", component: People},
        {path: "/people/:id", component: Person},
        {path: "/person-new", component: PersonNew},
        {path: "/networks", component: Networks},
        {path: "/network/:id", component: Network},
        {path: "/network-new", component: NetworkNew},
    ]
});

function hasRecentOidcLoginAttempt() {
    const raw = localStorage.getItem("oidc_login_started_at_ms");
    const value = Number(raw);
    if (!Number.isFinite(value) || value <= 0) return false;
    return (Date.now() - value) < 120000;
}

router.beforeEach((to, from, next) => {
    const hasOidcCallbackState = !!(to && to.query && (
        to.query.code ||
        to.query.state ||
        to.query.session
    ));
    if (hasOidcCallbackState && to.path !== "/auth/oidc/callback") {
        return next({path: "/auth/oidc/callback", query: to.query, replace: true});
    }

    const hasUser = !!localStorage.getItem("user");
    const hasPostLoginRedirectPending = localStorage.getItem("post_login_redirect_pending") === "1";
    if (
        !hasUser &&
        !hasRecentOidcLoginAttempt() &&
        !hasPostLoginRedirectPending &&
        to.path !== "/login" &&
        to.path !== "/auth/oidc/callback"
    )
        return next("/login");
    const isAdmin = localStorage.getItem("is_admin") === "1";
    const biobank = localStorage.getItem("biobank");
    const hasBiobank = !!biobank && biobank !== "null" && biobank !== "undefined";
    if (to.path === "/") {
        if (!hasUser && (hasRecentOidcLoginAttempt() || hasPostLoginRedirectPending)) {
            return next();
        }
        if (!hasUser) return next("/login");
        if (isAdmin) return next("/admin/access");
        if (!hasBiobank && hasUser) return next("/admin/access");
        return next(hasBiobank ? "/biobank" : "/user");
    }
    if (to.path === "/user" && !hasUser && hasRecentOidcLoginAttempt())
        return next("/");
    if (to.path.startsWith("/admin") && !isAdmin) {
        if (hasUser && !hasBiobank && hasRecentOidcLoginAttempt()) {
            return next();
        }
        return next(hasBiobank ? "/biobank" : "/user");
    }
    if (to.path === "/biobank" && !hasBiobank)
        return next("/user");
    if (
        isAdmin &&
        !hasBiobank &&
        !to.path.startsWith("/admin") &&
        !to.path.startsWith("/network") &&
        to.path !== "/networks" &&
        to.path !== "/login" &&
        to.path !== "/user"
    )
        return next("/admin/access");
    next();
});

new Vue({
    el: "#app",
    router,
    render: h => h(App)
});
